import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { infrastructuresRepo } from '@/constants/providers';

export const useEnableInfrastructureCost = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    infrastructuresRepo.enableInfrastructureCost(id),
  );
